module.exports = __webpack_public_path__ + "static/HabitatsTraitBreakdown-40fb61066fd25f6f8ee27c5d5c63cd34.pdf";